import * as d3 from "d3";

export default class MitDirectionsDisplayService {
    constructor(mapService) {
        this.mapService = mapService;
    }

    drawMarkers(startCoord, endCoord, isFinalDestination) {
        let layer = this.mapService.layerActiveRoute;
        if (!layer) return;
        
        // Green Start Marker
        if (startCoord) {
            let p1 = this.mapService.projection(startCoord);
            layer.append("circle")
                .attr("cx", p1[0])
                .attr("cy", p1[1])
                .attr("r", 8)
                .attr("fill", "#00C853") // Green
                .attr("stroke", "white")
                .attr("stroke-width", 2)
                .attr("class", "nav-start-marker");
        }

        // Destination Marker
        if (endCoord) {
            let p2 = this.mapService.projection(endCoord);
            
            if (isFinalDestination) {
                // Red Pin for final destination
                layer.append("path")
                    .attr("d", "M0,0 l-10,-20 a10,10 0 1,1 20,0 z")
                    .attr("transform", `translate(${p2[0]},${p2[1]})`)
                    .attr("fill", "#D50000")
                    .attr("stroke", "white")
                    .attr("stroke-width", 1)
                    .attr("class", "nav-end-marker");
            } else {
                // Blue Circle for Stairs / Elevators / Transitions
                layer.append("circle")
                    .attr("cx", p2[0])
                    .attr("cy", p2[1])
                    .attr("r", 8)
                    .attr("fill", "#2979FF") // Blue
                    .attr("stroke", "white")
                    .attr("stroke-width", 2)
                    .attr("class", "nav-transition-marker");
            }
        }
    }

    drawRoute(pathNodesArray) {
        let layer = this.mapService.layerActiveRoute;
        if (!layer || !pathNodesArray || pathNodesArray.length === 0) return;
        
        let routeCoordinates = [];
        
        pathNodesArray.forEach(f => {
            if (!f.geometry || !f.geometry.coordinates) return;
            
            if (f.geometry.type === 'Point') {
                let pt = f.geometry.coordinates;
                if (routeCoordinates.length === 0 || 
                    routeCoordinates[routeCoordinates.length-1][0] !== pt[0] ||
                    routeCoordinates[routeCoordinates.length-1][1] !== pt[1]) {
                    routeCoordinates.push(pt);
                }
            } else if (f.geometry.type === 'LineString') {
                let coords = f.geometry.coordinates;
                // BLIND APPEND: We trust the database oriented this correctly
                coords.forEach(pt => {
                    if (routeCoordinates.length === 0 || 
                        routeCoordinates[routeCoordinates.length-1][0] !== pt[0] ||
                        routeCoordinates[routeCoordinates.length-1][1] !== pt[1]) {
                        routeCoordinates.push(pt);
                    }
                });
            }
        });
        
        if (routeCoordinates.length < 2) return;

        let lineGenerator = d3.line()
            .x(coord => {
                let p = this.mapService.projection(coord);
                return p ? p[0] : 0;
            })
            .y(coord => {
                let p = this.mapService.projection(coord);
                return p ? p[1] : 0;
            });
            
        layer.append("path")
            .datum(routeCoordinates)
            .attr("d", lineGenerator)
            .attr("stroke", "#ffca28")
            .attr("stroke-width", 6)
            .attr("stroke-linecap", "round")
            .attr("stroke-linejoin", "round")
            .attr("fill", "none")
            .style("opacity", 0.9)
            .style("pointer-events", "none")
            .attr("class", "nav-route-line");
    }

    clearRoute() {
        if (this.mapService.layerActiveRoute) {
            this.mapService.layerActiveRoute.selectAll("*").remove();
        }
    }
}